@let _isInsideSection = isInsideSection();
@if ((features?.classifications.length > 0 && _isInsideSection) || (activeAgecLaw && agecLaw)) {
  @let _brand = brand();
  <sd-component-wrapper
    id="{{ componentId }}"
    [content]="_isInsideSection ? null : wrapperContent"
    [themesConfig]="lameConfig?.backgroundTheme"
    [brand]="_brand"
    [marginSize]="_isInsideSection ? MarginEnum.without_margin : MarginEnum.default_margin"
    [componentWidth]="_isInsideSection ? ComponentWrapperWidthEnum.absoluteFullWidth : ComponentWrapperWidthEnum.default"
  >
    <ng-container sd-component-wrapper-component>
      @if (_isInsideSection && showFeaturesTab) {
          <sd-table-features [features]="features"/>
      } @else if (activeAgecLaw) {
        @if (agecLaw) {
          <aside>
            <ng-container>
              <sd-table-features [isOpen]="true" [features]="featuresAgecLaw"/>
            </ng-container>

            @if (substanceProducts.length > 0) {
              <sd-table-features [isOpen]="false" [features]="featuresSubstance"/>
            }
          </aside>
        } @else {
          <p>{{ 'pdp.characteristicstable.tab.environnement.nodata' | translate }}</p>
        }
      }
    </ng-container>
  </sd-component-wrapper>
}
